import Obstruction from '../Objects/Obstruction';
import OutlinePoints from '../Objects/OutlinePoints';
import { CHIMNEY_OBSTRUCTION, WATERTANK_OBSTRUCTION } from '../utilities/constants';
import * as utils from '../utilities/utils'
import ArcMeasurement from './ArcMeasurement';
import LengthMeasurement from './LengthMeasurement';
export default class PolygonMeasurement {
    constructor(vertices, parent, stage, editable = true) {
        // standard norms
        this.stage = stage;

        this.parent = parent;
        this.vertices = vertices;
        this.arcEnabled = true;

        // make vertices clockwise
        if (!utils.checkClockwise(this.parent.get2DVertices())) {
            this.vertices.reverse();
        }
        if ((this.parent instanceof Obstruction &&
            [WATERTANK_OBSTRUCTION, CHIMNEY_OBSTRUCTION].includes(this.parent.obstructionType)
        )) {
            this.arcEnabled = false;
        }

        // add length and arc measurement object
        this.init();
    }

    _getPreviousVertexIndex(index) {
        if (index === 0) {
            return this.vertices.length - 1;
        } else
            return index - 1;
    }

    _getNextVertexIndex(index) {
        if (index === this.vertices.length - 1) {
            return 0;
        } else
            return index + 1;
    }

    init() {
        this.lengthElements = [];
        this.arcElements = [];
        for (let i = 0; i < (this.vertices.length === 2 ? 1: this.vertices.length); i++) {
            let prevIndex = this._getPreviousVertexIndex(i);
            let nextIndex = this._getNextVertexIndex(i);
            this.lengthElements.push(
                new LengthMeasurement(this.vertices[i], this.vertices[(i + 1) % this.vertices.length], this.stage, this));
            // if (this.arcEnabled) this.arcElements.push(
            //     new ArcMeasurement(this.vertices[prevIndex], this.vertices[i], this.vertices[nextIndex], this.stage, this));
        }
    }

    show() {
        for (let i = 0; i < (this.vertices.length === 2 ? 1: this.vertices.length); i++) {
            this.lengthElements[i].show(this.editable);
            this.lengthElements[i].textObject.textMesh.sync();
            // if (this.arcEnabled) {
            //     if (this.stage.arcVisible) {
            //         this.arcElements[i].show(this.editable);
            //         this.arcElements[i].textObject.visible = true;
            //         this.arcElements[i].textObject.update();
            //         this.arcElements[i].textObject.textMesh.sync();
            //     } else {
            //         this.arcElements[i].hide();
            //         this.arcElements[i].textObject.visible = false;
            //         this.arcElements[i].textObject.update();
            //     }
            // }
        }
    }

    showLength() {
        for (let i = 0; i < (this.vertices.length === 2 ? 1: this.vertices.length); i++) {
            this.lengthElements[i].textObject.visible = true;
            this.lengthElements[i].textObject.showObject();
        }
    }

    showArc() {
        if (!this.arcEnabled) return null;
        // for (let i = 0; i < (this.vertices.length === 2 ? 1: this.vertices.length); i++) {
        //     this.arcElements[i].show(this.editable);
        //     this.arcElements[i].textObject.visible = true;
        //     this.arcElements[i].textObject.update();
        // }
    }

    hide() {
        for (let i = 0; i < (this.vertices.length === 2 ? 1: this.vertices.length); i++) {
            this.lengthElements[i] && this.lengthElements[i].hide();
            // if (this.arcEnabled) this.arcElements[i] && this.arcElements[i].hide();
        }
    }

    hideLength() {
        for (let i = 0; i < (this.vertices.length === 2 ? 1: this.vertices.length); i++) {
            this.lengthElements[i].textObject.visible = false;
            this.lengthElements[i].textObject.hideObject();
        }
    }

    hideArc() {
        for (let i = 0; i < (this.vertices.length === 2 ? 1: this.vertices.length); i++) {
            if (this.arcElements[i]) {
                this.arcElements[i].hide();
                this.arcElements[i].textObject.visible = false;
            }
        }
    }

    enable() {
        for (let i = 0; i < (this.vertices.length === 2 ? 1: this.vertices.length); i++) {
            this.lengthElements[i].enable();
            // if (this.arcEnabled) this.arcElements[i].enable();
        }
    }

    disable() {
        for (let i = 0; i < (this.vertices.length === 2 ? 1: this.vertices.length); i++) {
            this.lengthElements[i].disable();
            // if (this.arcEnabled) this.arcElements[i].disable();
        }
    }

    update(updatedVertices = []) {
        if (!utils.checkClockwise(this.get2DVertices())) {
            this.vertices.reverse();
            this.remove();
            this.init();
            this.show();
            // update dragIndex
            this.dragIndex = (this.lengthElements.length - 1) - this.dragIndex;
        }
        if (updatedVertices.length === 0 ) {
            for (let i = 0; i < (this.vertices.length === 2 ? 1: this.vertices.length); i++) {
                this.lengthElements[i].update();
                // if (this.arcEnabled) this.arcElements[i].update();
            }
        } else {
            for (let i = 0; i < (updatedVertices.length === 2 ? 1: updatedVertices.length); i++) {
                let prevIndex = this._getPreviousVertexIndex(i);
                let nextIndex = this._getNextVertexIndex(i);
                this.lengthElements[i].update(updatedVertices[i], updatedVertices[(i+1) % updatedVertices.length]);
                // if (this.arcEnabled) this.arcElements[i].update(updatedVertices[prevIndex], updatedVertices[i], updatedVertices[nextIndex]) ;
            }
        }
    }

    remove() {
        for (let i = this.lengthElements.length - 1; i >= 0; i--) {
            this.lengthElements[i].remove();
            this.lengthElements.splice(i, 1);
        }

        // if (this.arcEnabled) {
        //     for (let i = this.arcElements.length - 1; i >= 0; i--) {
        //         this.arcElements[i].remove();
        //         this.arcElements.splice(i, 1);
        //     }
        // }
    }

    get2DVertices() {
        let vertices = [];
        for (let vertex of this.vertices) {
            vertices.push([
                vertex instanceof OutlinePoints ? vertex.getPosition().x : vertex.clone().x,
                vertex instanceof OutlinePoints ? vertex.getPosition().y : vertex.clone().y,
            ])
        }
        return vertices;
    }
}